import { type UserLogin } from 'auth/domain/UserLogin'

export type RawUserLogin = {
  jwt_token: string
  visual_token: string
  user: string
  captchaToken: string
}

export type RawLogin = {
  email: string
  password: string
}

export type TokenRequest = {
  auth_code: string
  code_verifier: string
}

export type TokenResponse = {
  access_token: string
  refresh_token: string
  user: string
}

export type OpenDockLoginRequest = {
  email: string
  password: string
  captchaToken: string
}

export type OpenDockUser = {
  email: string
  first_name: string
  last_name: string
  client: string
  issuer: string
}

export type OpenDockTokenResponse = {
  access_token: string
  expires_in: number
  user: OpenDockUser
}

export function mapApiToUserLogin(userLogin: RawUserLogin): UserLogin {
  return {
    accessToken: userLogin.jwt_token,
    visualToken: userLogin.visual_token,
    userLogin: userLogin.user,
    captchaToken: userLogin.captchaToken
  }
}

export function mapTokenApiToUserLogin(tokenResponse: TokenResponse): UserLogin {
  return {
    accessToken: tokenResponse.access_token,
    visualToken: "",
    userLogin: tokenResponse.user,
    captchaToken: "",
  }
}

export function mapOpenDockApiToUserLogin(tokenResponse: OpenDockTokenResponse): UserLogin {
  // Store the full user object as JSON string to match the pattern used by other authentication methods
  // The backend for standard/BIP login returns user as a JSON string, so we do the same for OpenDock
  const userObject = {
    email: tokenResponse.user.email,
    first_name: tokenResponse.user.first_name || '',
    last_name: tokenResponse.user.last_name || '',
    client: tokenResponse.user.client,
    issuer: tokenResponse.user.issuer,
  }

  return {
    accessToken: tokenResponse.access_token,
    visualToken: "",
    userLogin: JSON.stringify(userObject),
    captchaToken: "",
  }
}
